module.exports = __webpack_public_path__ + "img/170520.ed099b30.png";